import React from 'react';
import { Box } from '@mui/material';
import Navbar from '@/components/home/Navbar';
import DepartmentMonitoringIndicatorManager from '@/components/department-monitoring/DepartmentMonitoringIndicatorManager';

const DepartmentMonitoringIndicatorPage: React.FC = () => {
  return (
    <Box>
      <Navbar />
      <Box sx={{ p: 3 }}>
        <DepartmentMonitoringIndicatorManager />
      </Box>
    </Box>
  );
};

export default DepartmentMonitoringIndicatorPage;

